/* ============================================
   KAFFEESACK — Vendor Utilities v1.0
   Scroll-snap carousel · Focus trap
   ============================================ */

(function() {
  'use strict';

  /* ─── SCROLL-SNAP CAROUSEL ─── */
  window.KSCarousel = function(container, opts) {
    if (!container) return null;

    var o = Object.assign({
      cellSelector: null,
      prevBtn: null,
      nextBtn: null,
      dots: null,
      loop: false,
      autoplay: 0,
      onChange: null
    }, opts || {});

    var cells = o.cellSelector
      ? Array.from(container.querySelectorAll(o.cellSelector))
      : Array.from(container.children);

    if (cells.length < 1) return null;

    var current = 0;
    var autoplayTimer = null;
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    function getCurrent() {
      var containerRect = container.getBoundingClientRect();
      var center = containerRect.left + containerRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;

      for (var i = 0; i < cells.length; i++) {
        var rect = cells[i].getBoundingClientRect();
        var cellCenter = rect.left + rect.width / 2;
        var dist = Math.abs(cellCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      }
      return closest;
    }

    function goTo(index) {
      if (index < 0) index = o.loop ? cells.length - 1 : 0;
      if (index >= cells.length) index = o.loop ? 0 : cells.length - 1;

      cells[index].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });

      current = index;
      updateDots();
      if (o.onChange) o.onChange(current);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function updateDots() {
      if (!o.dots) return;
      var dotEls = o.dots.children;
      for (var i = 0; i < dotEls.length; i++) {
        dotEls[i].classList.toggle('is-active', i === current);
      }
    }

    /* Scroll listener to detect current slide */
    var scrollTimer = null;
    container.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        current = getCurrent();
        updateDots();
        if (o.onChange) o.onChange(current);
      }, 100);
    }, { passive: true });

    /* Button bindings */
    if (o.prevBtn) {
      o.prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        prev();
        stopAutoplay();
      });
    }

    if (o.nextBtn) {
      o.nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        next();
        stopAutoplay();
      });
    }

    /* Dot click */
    if (o.dots) {
      o.dots.addEventListener('click', function(e) {
        var dot = e.target.closest('[data-index]') || e.target;
        var idx = Array.from(o.dots.children).indexOf(dot);
        if (idx >= 0) {
          goTo(idx);
          stopAutoplay();
        }
      });
    }

    /* Autoplay */
    function startAutoplay() {
      if (o.autoplay <= 0) return;
      stopAutoplay();
      autoplayTimer = setInterval(next, o.autoplay);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    /* Pause on hover/touch */
    container.addEventListener('mouseenter', stopAutoplay);
    container.addEventListener('mouseleave', function() {
      if (o.autoplay > 0) startAutoplay();
    });
    container.addEventListener('touchstart', stopAutoplay, { passive: true });

    /* Initialize */
    updateDots();
    if (o.autoplay > 0) startAutoplay();

    return {
      goTo: goTo,
      next: next,
      prev: prev,
      getCurrent: getCurrent,
      destroy: function() {
        stopAutoplay();
      }
    };
  };


  /* ─── FOCUS TRAP ─── */
  window.KSFocusTrap = function(container) {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var active = false;
    var previousFocus = null;

    function getFocusable() {
      return Array.from(container.querySelectorAll(FOCUSABLE)).filter(function(el) {
        return el.offsetParent !== null;
      });
    }

    function handleKeydown(e) {
      if (e.key !== 'Tab' || !active) return;

      var focusable = getFocusable();
      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    return {
      activate: function() {
        if (active) return;
        active = true;
        previousFocus = document.activeElement;
        document.addEventListener('keydown', handleKeydown);
        var focusable = getFocusable();
        if (focusable.length > 0) {
          focusable[0].focus();
        }
      },
      deactivate: function() {
        if (!active) return;
        active = false;
        document.removeEventListener('keydown', handleKeydown);
        if (previousFocus && previousFocus.focus) {
          previousFocus.focus();
        }
      },
      isActive: function() { return active; }
    };
  };

})();
